<template>
  <div class="dsig">
    <Menu />
    <div class="inner">
      <div class="bnr">
        <div class="cont bcont">
          <div class="bleft">
            <div class="btitles">
              <div class="btitle1">
                <h1 class="btitle1t1">稳定、精准、真高清</h1>
                <div class="btitle1img_bx">
                  <img
                    class="btitle1img"
                    src="https://todeskcdnspeed.todesk.com/mobile/design/picon.svg"
                    alt=""
                  />
                </div>
              </div>
              <h1 class="btitle1t1">远程设计生产力，全开！</h1>
            </div>
          </div>
          <div class="bright">
            <video
              preload="auto"
              playsinline
              playsinlinex5-video-player-type="h5"
              x5-video-player-fullscreen="true"
              x5-playsinline="true"
              x-webkit-airplay="allow"
              x5-video-orientation="landscape|portrait"
              style="object-fit: fill"
              webkit-playsinline="true"
              x5-video-player-type="h5-page"
              class="brvideo"
              autoplay
              muted
              loop
            >
              <source
                src="https://todeskcdnspeed.todesk.com/202206121646015e13c337a1451c.mp4"
                type="video/mp4"
              />
              您的浏览器不支持Video标签。
            </video>
          </div>
          <div class="bbtns">
            <a id="ep_hd_bnr_trial_btn1" class="btn1 epBtn1" :href="to_register"
              >即刻体验</a
            >
            <a id="ep_hd_bnr_wbook_btn1" class="btn2 epBtn2" :href="wbook"
              >获取白皮书</a
            >
          </div>
        </div>
      </div>
      <Partner :logo_list="logo_list" :maxWidth="520" />
      <div class="scenes">
        <div class="cont scont">
          <h5 class="subtitle">适用场景</h5>
          <h2 class="stitle">知设计所需，更懂你所想</h2>
          <div class="sbox">
            <div
              class="sboxitem"
              v-for="(item, index) in scenes_list"
              :key="index"
            >
              <img class="sipic" :src="item.pic" :alt="item.title" />
              <div class="siinfo">
                <p class="siinfo_title">{{ item.title }}</p>
              </div>
            </div>
          </div>
          <a id="ep_hd_apply_trial_btn1" class="epBtn1 btnf" :href="to_register"
            >免费试用</a
          >
        </div>
      </div>
      <div class="pdn smooth">
        <div class="cont stcont">
          <h2 class="stTitle">顺畅运行</h2>
          <div class="stItems">
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/MAYA.png" alt="maya" />
            </p>
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/UNITY.png" alt="unity" />
            </p>
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/3DS.png" alt="3ds max" />
            </p>
          </div>
          <div class="stItems">
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/HUODINI.png" alt="houdini" />
            </p>
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/UNREAL.png" alt="unreal" />
            </p>
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/id.png" alt="id" />
            </p>
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/PS.png" alt="ps" />
            </p>
          </div>
          <div class="stItems">
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/SAI.png" alt="sai" />
            </p>
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/ZB.png" alt="zbrush" />
            </p>
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/CREO.png" alt="creo" />
            </p>
          </div>
          <div class="stItems">
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/BLENDER.png" alt="blender" />
            </p>
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/C4D.png" alt="cinema 4d" />
            </p>
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/INV.png" alt="inventor" />
            </p>
          </div>
          <div class="stItems">
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/RHINO.png" alt="rhino" />
            </p>
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/ALIAS.png" alt="alias" />
            </p>
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/AUTOCAD.png" alt="auto cad" />
            </p>
          </div>
          <div class="stItems">
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/SOLID.png" alt="solid works" />
            </p>
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/VRAY.png" alt="vray" />
            </p>
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/LUMION.png" alt="lumion" />
            </p>
          </div>
          <div class="stItems">
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/CORO.png" alt="corona" />
            </p>
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/REVIT.png" alt="revit" />
            </p>
            <p class="item">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/runok/SKETCHUP.png" alt="sketch up" />
            </p>
          </div>
          <p class="soon">……</p>
          <a id="ep_hd_frun_trial_btn1" class="epBtn1 btnf" :href="to_register"
            >免费试用</a
          >
        </div>
        <img class="stbkg" src="https://todeskcdnspeed.todesk.com/mobile/design/smooth_bkg.svg" alt="" />
      </div>
      <div class="hd">
        <div class="cont hdcont">
          <div class="hd_left">
            <h2 class="hdtitle">ToDesk 真高清为你而来</h2>
            <p class="hditem">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/right@2x.svg" alt="" />
              <span class="text">4K高清画面，不丢失设计细节</span>
            </p>
            <p class="hditem">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/right@2x.svg" alt="" />
              <span class="text">0.04秒无感延时，鼠标指哪儿打哪儿</span>
            </p>
            <!-- <p class="hditem">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/right@2x.svg" alt="" />
              <span class="text">体感卡顿率≤0.3%，流畅工作更高效</span>
            </p> -->
            <p class="hditem">
              <img src="https://todeskcdnspeed.todesk.com/mobile/design/right@2x.svg" alt="" />
              <span class="text">兼容8192数位板，坐标压感都精准</span>
            </p>
          </div>
          <div class="hd_right">
            <img
              class="hd_right_pic"
              src="https://todeskcdnspeed.todesk.com/mobile/design/hd.png"
              alt="ToDesk"
            />
            <a
              id="ep_hd_real_dl_btn1"
              class="hd_mention"
              href="https://enterprise.todesk.com/download"
            >
              <p class="p1">“</p>
              <p class="p2">不背工作站回家<br />告别VPN卡顿</p>
              <p class="p3">”</p>
            </a>
          </div>
          <a id="ep_hd_real_prcts_btn1" class="hdlink" :href="to_register"
            ><span class="hdlink_text">开启远程设计新体验</span
            ><img src="https://todeskcdnspeed.todesk.com/mobile/design/right.svg" alt=""
          /></a>
        </div>
      </div>
      <div class="given">
        <div class="cont gcont">
          <h2 class="gtitle">好用真高清，远不止高清</h2>
          <h5 class="subtitle">稳定 · 流畅 · 低延时 · 高可用</h5>
          <video
            preload="auto"
            playsinline
            playsinlinex5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-playsinline="true"
            x-webkit-airplay="allow"
            x5-video-orientation="landscape|portrait"
            style="object-fit: fill"
            webkit-playsinline="true"
            x5-video-player-type="h5-page"
            class="gvideo"
            autoplay
            muted
            loop
          >
            <source
              src="https://todeskcdnspeed.todesk.com/202206121646375e13c359e70f44.mp4"
              type="video/mp4"
            />
            您的浏览器不支持Video标签。
          </video>
          <div class="bdesc">眼见不一定为实，但体验绝不会说谎</div>
          <a id="ep_hd_video_see_btn1" class="epBtn1 btnq" :href="to_register"
            >亲自验货</a
          >
        </div>
      </div>
      <div class="core">
        <div class="cont cocont">
          <div class="coLeft">
            <h2 class="coTitle">首发RTC引擎</h2>
            <h2 class="coTitle">
              远程体验<span class="coTitle1">焕然“芯”生</span>
            </h2>
            <p class="coDesc coDesc1">
              RTC
              是专为实时高清而生的前沿技术，对整个音视频编码、网络传输、图像处理过程进行了整体重构和优化，也是下一代4K超清实时传输的必备框架。
            </p>
            <p class="coDesc">
              ToDesk
              将RTC引擎引入远程软件，这是行业中的一大步，但只是ToDesk追求极致用户体验之路上的一小步。
            </p>
          </div>
          <img
            class="coRightImg"
            src="https://todeskcdnspeed.todesk.com/mobile/design/rtc.svg"
            alt="首发RTC引擎"
          />
        </div>
      </div>
      <div class="core stable">
        <div class="cont cocont">
          <div class="coLeft">
            <h2 class="coTitle"><span class="coTitle1">持久稳定</span>连接</h2>
            <h2 class="coTitle">不为创作中断而糟心</h2>
            <p class="coDesc coDesc1">
              远程设计时遇到连接中断，不仅会打断设计思路，还可能造成未保存内容的丢失。
            </p>
            <p class="coDesc">
              ToDesk
              独家传输算法能够扛住更猛烈的网络抖动，且有智能网络规划主动绕开拥塞线路，多管齐下保障连接稳定，助您的远程设计一气呵成。
            </p>
          </div>
          <img
            class="coRightImg"
            src="https://todeskcdnspeed.todesk.com/mobile/design/wending.svg"
            alt="持久稳定连接"
          />
        </div>
      </div>
      <div class="core">
        <div class="cont cocont">
          <div class="coLeft">
            <h2 class="coTitle">流畅视角转动与画面缩放</h2>
            <h2 class="coTitle">
              沉浸设计才<span class="coTitle1">高效</span>
            </h2>
            <p class="coDesc coDesc1">
              图形类工作需要频繁缩放画面和转动视角，卡顿会严重影响体验，引发焦躁也更易疲劳。
            </p>
            <p class="coDesc">
              全新高清版中，ToDesk
              配合RTC框架优化多个核心算法，在家用宽带的实机环境下，也能让2K画面实现每秒60帧的流畅显示。
            </p>
          </div>
          <img
            class="coRightImg"
            src="https://todeskcdnspeed.todesk.com/mobile/design/gaoxiao.svg"
            alt="高效"
          />
        </div>
      </div>
      <div class="core stable">
        <div class="cont cocont">
          <div class="coLeft">
            <h2 class="coTitle"><span class="coTitle1">无感</span>低延时</h2>
            <h2 class="coTitle">操作精准媲美本地电脑</h2>
            <p class="coDesc coDesc1">
              ToDesk高清版延时低至0.04秒，肉眼几乎无法感知。无论是鼠标移动、文字输入还是数位板触控，都能立刻在屏幕上看到相应反馈，操作体验和本地电脑几乎没有区别。
            </p>
            <p class="coDesc">
              超低延时让创作者的每一个动作都无需等待，大幅减少误操作，提升远程设计质量。
            </p>
          </div>
          <img
            class="coRightImg"
            src="https://todeskcdnspeed.todesk.com/mobile/design/wuyanshi.png"
            alt="低延时"
          />
        </div>
      </div>
      <div class="net">
        <div class="cont netcont">
          <h2 class="netitle">好高清，离不开好网络</h2>
          <div class="netcp">
            <div class="netinfo netc">
              <img class="nicon" src="https://todeskcdnspeed.todesk.com/mobile/design/good.png" alt="" />
              <div>
                <h4 class="nettitle">
                  <span class="nettitle1">ToDesk</span> 自带OTT SD-WAN网络优化
                </h4>
                <h6 class="netsubtitle">
                  更丰富转发节点和可用线路，实时智能规划绕开拥堵
                </h6>
              </div>
              <img class="descImg" src="https://todeskcdnspeed.todesk.com/mobile/design/ott.png" alt="OTT" />
            </div>
            <img class="vsImg" src="https://todeskcdnspeed.todesk.com/mobile/design/vs.svg" alt="VS" />
            <div class="netinfo neto">
              <div>
                <h4 class="nettitle">传统BGP机房转发</h4>
                <h6 class="netsubtitle">
                  机房之间不互通不组网，不能获得全局最优线路
                </h6>
              </div>
              <img class="descImg" src="https://todeskcdnspeed.todesk.com/mobile/design/bgp.png" alt="bgp" />
            </div>
          </div>
        </div>
      </div>
      <div class="operation">
        <div class="cont opcont">
          <div class="opTitle">企业级安全的远程办公</div>
          <div class="optBtns">
            <a
              id="ep_hd_btm_see_btn1"
              class="epBtn1 ctcBtn ctcBtn1"
              :href="to_register"
              >即刻体验</a
            >
            <a
              id="ep_hd_btm_wbook_btn1"
              class="epBtn2 ctcBtn ctcBtn2"
              :href="wbook"
              >获取白皮书</a
            >
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import Partner from "@/components/Partner.vue";
import { mapState } from "vuex";
import { videoReady } from "../../utils/util";
export default {
  components: {
    Menu,
    Footer,
    Partner,
  },
  data() {
    return {
      scenes_list: [
        {
          title: "3D建模与PBR",
          pic: "https://todeskcdnspeed.todesk.com/mobile/design/scenes_3d.png",
          desc: "稳定60fps 高清画面搭配0.04秒低延时精准操控，流畅完成建模、精雕、动作绑定、贴图渲染，无论团队身处何方，复杂PBR 都能一气呵成",
          show_desc: false,
        },
        {
          title: "插画原画",
          pic: "https://todeskcdnspeed.todesk.com/mobile/design/scenes_chahua.png",
          desc: "支持高保真色彩传输和2048级数位板兼容，不丢失任何创作细节，让每一位画师都能随时随地捕捉灵感，成就大触梦想",
          show_desc: false,
        },
        {
          title: "引擎开发",
          pic: "https://todeskcdnspeed.todesk.com/mobile/design/scenes_yinqing.png",
          desc: "“零信任”数据保护+高清工作画面，针对游戏引擎开发机密度高、代码与美术相结合的特点，提供安全流畅的灵活开发手段",
          show_desc: false,
        },
        {
          title: "影视与动画",
          pic: "https://todeskcdnspeed.todesk.com/mobile/design/scenes_yingshi.png",
          desc: "流畅2K+毫秒级操作响应，为影视剪辑和动画制作提供了优质的远程工作方案，克服笔记本性能薄弱与超大素材拷贝难题",
          show_desc: false,
        },
        {
          title: "建筑设计",
          pic: "https://todeskcdnspeed.todesk.com/mobile/design/scenes_jianzhusheji.png",
          desc: "远程桌面有了流畅的视角转动和高精度操作，只需一台轻薄本，就能顺畅完成复杂曲面建模和效果图渲染，同时解决项目文件的保密问题",
          show_desc: false,
        },
        {
          title: "室内设计",
          pic: "https://todeskcdnspeed.todesk.com/mobile/design/scenes_shineisheji.png",
          desc: "通过ToDesk的高清远程桌面和网络优化服务，无论是在会议室还是咖啡厅，设计师都可以在方案上边演示边修改，提升效率和客户满意度",
          show_desc: false,
        },
        {
          title: "工程作图",
          pic: "https://todeskcdnspeed.todesk.com/mobile/design/scenes_zhitu.png",
          desc: "支持流畅画面缩放和精准光标落点，让远程设计得心应手，并实现海量图纸的统一管理，广泛适用于机械设计、城市规划、结构设计、BIM管理",
          show_desc: false,
        },
        {
          title: "芯片设计",
          pic: "https://todeskcdnspeed.todesk.com/mobile/design/scenes_xinpian.png",
          desc: "提供“数据不落地”远程设计方案，在所有IP寸步不离公司设备的前提下加快研发效率、提升工作灵活性，让企业更能吸引全球顶尖人才",
          show_desc: false,
        },
      ],
      logo_list: [
        require("@/assets/partner/zhangqu.png"),
        // require('@/assets/partner/xuanjikeji.png'),
        require("@/assets/partner/ennead@2x.png"),
      ],
    };
  },
  methods: {},
  computed: {
    ...mapState(["to_register", "wbook"]),
  },
  mounted() {
    videoReady();
  },
};
</script>
<style lang="less" scoped>
.inner {
  .bnr {
    background: linear-gradient(180deg, #ffffff 0%, #ffffff 77%, #f8f9fb 100%);
    padding: 36px 30px 24px;
    box-sizing: border-box;
    text-align: center;
    .btitle1t1 {
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
    }
    .btitle1img_bx {
      width: 100%;
      text-align: right;
    }
    .btitle1img {
      width: 97px;
      margin-right: 25px;
    }
    .brvideo {
      width: 100%;
      margin-top: 13px;
    }
    .bbtns {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .btn1 {
        height: 54px;
        width: 156px;
        line-height: 54px;
        margin-right: 15px;
      }
      .btn2 {
        height: 54px;
        width: 156px;
        line-height: 52px;
      }
    }
  }
  .scenes {
    background: #fff;
    padding-top: 32px;
    padding-bottom: 32px;
    text-align: center;
    .subtitle {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #585f69;
    }
    .stitle {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
      margin-top: 8px;
    }
    .sbox {
      margin-top: 32px;
      display: flex;
      justify-content: center;
      flex-flow: row wrap;
      .sboxitem {
        margin-left: 2px;
        margin-right: 2px;
        width: 80px;
        height: 80px;
        position: relative;
        border-radius: 2px;
        overflow: hidden;
        margin-top: 4px;
        .sipic {
          width: 100%;
          height: 100%;
        }
        .siinfo {
          position: absolute;
          width: 100%;
          height: 48px;
          bottom: 0;
          left: 0;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.36) 36%,
            rgba(0, 0, 0, 0.68) 100%
          );
          color: #fff;
          font-size: 14px;
          display: flex;
          align-items: flex-end;
          padding-bottom: 10px;
          box-sizing: border-box;
          justify-content: center;
        }
      }
    }
  }
  .smooth {
    background: linear-gradient(315deg, #eaeff6 0%, #f5fdff 100%);
    text-align: center;
    position: relative;
    .stbkg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
    }
    .stTitle {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
      margin-bottom: 24px;
    }
    .stItems {
      display: flex;
      justify-content: center;
      .item {
        height: 37px;
        padding-left: 14px;
        padding-right: 14px;
        display: flex;
        align-items: center;
        background: #fcfcff;
        box-shadow: 0px 3px 13px 0px rgba(0, 24, 50, 0.08),
          inset 0px -1px 0px 0px #dfe3e8;
        border-radius: 4px;
        margin-right: 7px;
        margin-bottom: 7px;
        img {
          height: 18px;
          width: auto;
        }
      }
      .item:last-of-type {
        margin-right: 0;
      }
    }
    .soon {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #90959c;
      line-height: 33px;
    }
  }
  .hd {
    background: #fff;
    padding-top: 32px;
    padding-bottom: 24px;
    .hdcont {
      .hdtitle {
        text-align: center;
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222429;
        margin-bottom: 4px;
      }
    }
    .hditem {
      margin-top: 12px;
      display: flex;
      align-items: center;
      padding-left: 62px;
      img {
        width: 16px;
        height: auto;
      }
      span {
        margin-left: 2px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #585f69;
      }
    }
    .hd_right {
      margin-top: 24px;
      padding-left: 24px;
      padding-right: 24px;
      width: 100%;
      position: relative;
      box-sizing: border-box;
      .hd_right_pic {
        width: 100%;
      }
      .hd_mention {
        position: absolute;
        width: 154px;
        height: 68px;
        background: rgba(4, 114, 248, 0.83);
        border-radius: 4px;
        right: 64px;
        bottom: -16px;
        display: flex;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        padding: 15px 11px;
        box-sizing: border-box;
        .p1 {
          position: relative;
          top: -5px;
        }
        .p2 {
          margin-left: 5px;
        }
        .p3 {
          position: relative;
          top: 23px;
        }
        &:active {
          background: rgba(4, 114, 248, 1);
        }
      }
    }
    .hdlink {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #0070f9;
      margin: auto;
      margin-top: 40px;
      justify-content: center;
      img {
        margin-left: 4px;
        width: 14px;
      }
      &:active {
        opacity: 0.7;
      }
    }
  }
  .given {
    background: #29303a;
    padding-top: 32px;
    padding-bottom: 32px;
    text-align: center;
    .gtitle {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
    }
    .subtitle {
      margin-top: 8px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
    }
    .gvideo {
      width: 100%;
      margin-top: 24px;
      padding-left: 23px;
      padding-right: 23px;
      box-sizing: border-box;
    }
    .bdesc {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      margin-top: 18px;
    }
    .btnq {
      display: block;
      width: 311px;
      background: #0065dd;
      line-height: 48px;
      font-size: 18px;
      margin: auto;
      margin-top: 32px;
    }
  }
  .core {
    background: #fff;
    padding-top: 32px;
    padding-bottom: 32px;
    text-align: center;
    .coTitle {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
      line-height: 33px;
    }
    .coTitle1 {
      color: #0070f9;
    }
    .coDesc {
      margin: auto;
      margin-top: 24px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #585f69;
      width: 327px;
      text-align: initial;
    }
    .coRightImg {
      margin-top: 24px;
      width: 337px;
    }
  }
  .core.stable {
    background: #f4f5f6;
  }
  .net {
    background: #fff;
    padding: 32px 24px;
    text-align: center;
    .netitle {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
      margin-bottom: 8px;
    }
    .netinfo {
      position: relative;
      width: 327px;
      border-radius: 4px;
      background: #fafbfc;
      padding-top: 24px;
      padding-bottom: 8px;
    }
    .netc {
      border: 3px solid rgba(0, 101, 221, 0.3);
    }
    .neto {
      background: #edf0f2;
    }
    .nicon {
      position: absolute;
      width: 28px;
      right: 2px;
      top: 0;
    }
    .descImg {
      width: 315px;
      height: 152px;
      margin-top: 8px;
    }
    .nettitle {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
      .nettitle1 {
        color: #0065dd;
      }
    }
    .netsubtitle {
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #585f69;
      margin-top: 8px;
    }
    .vsImg {
      width: 48px;
      margin-top: -16px;
      margin-bottom: -16px;
      position: relative;
      z-index: 1;
    }
  }
  .operation {
    // background: #f4f5f6;
    text-align: center;
    padding-top: 32px;
    padding-bottom: 40px;
    width: 100%;
    background: #ffffff;
    background-image: url("~@/assets/epindex/bkg.png");
    background-repeat: no-repeat;
    background-size: cover;
    box-sizing: border-box;
    .opTitle {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
    }
    .optBtns {
      margin-top: 32px;
      display: flex;
      justify-content: center;
    }
  }
}

.btnf {
  width: 144px;
  line-height: 48px;
  display: inline-block;
  margin: auto;
  margin-top: 20px;
  font-size: 18px;
}
</style>
